var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "non-blocking-modal" }, [
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("h4", [_vm._v("Resend move completion email")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "l-modal-close",
            on: { click: _vm.sendMovingContractEmail }
          },
          [_vm._m(0)]
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-1" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary ld-ext-right w-100",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.sendMovingContractEmail(true)
                }
              }
            },
            [
              _vm._v("\n        Yes, send email\n        "),
              _c("div", { staticClass: "ld ld-ball ld-flip" })
            ]
          ),
          _vm._v(" "),
          _c("error-field", { attrs: { errors: _vm.errors, field: "error" } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn btn-close" }, [
      _c("span", { staticClass: "mod-icon-close opacity-50" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "alert-danger border-red p-2 rounded" }, [
          _c("p", [
            _vm._v(
              "You are about to edit a completed job, this will resend services contract email to the customer."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Please click “Yes, send email” to approve updates made on the job and send the email to the Customer once you’re done with making changes."
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "strong text-danger" }, [
            _vm._v(
              "Otherwise, the email will be sent automatically 10 minutes after the last update was made."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc46280e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc46280e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/SendEmailConfirmation.vue
// module id = null
// module chunks = 